import { Link } from 'react-router-dom';
import { ScanFace } from 'lucide-react';
import { PLATFORM_NAME } from '../lib/constants';

export const PoweredBy = ({ hidden = false, className = '' }) => {
  if (hidden) return null;
  return (
    <Link
      to="/"
      data-testid="powered-by-footer"
      className={`flex items-center justify-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-cyan transition-colors py-6 ${className}`}
    >
      <ScanFace className="w-3.5 h-3.5 text-cyan" />
      Powered by <span className="text-white font-bold">{PLATFORM_NAME}</span>
    </Link>
  );
};
